let init = function (form_container) {
  const labels = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";

  function init_inputs() {
    const widgets = form_container.querySelectorAll("[data-merchants-lookup]");

    widgets.forEach((widget) => {
      const mapElement = widget.querySelector("[data-merchants-lookup-map]");
      const state = {
        postcodeInput: widget.querySelector("[data-merchants-lookup-input]"),
        resultsContainer: widget.querySelector("[data-merchants-lookup-list]"),
        merchantSelection: widget.querySelector(
          `[name=${widget.dataset.merchantsLookupValueKey}]`,
        ),
        searchButton: widget.querySelector(
          "[data-merchants-lookup-search-button]",
        ),
        mapLoadingSpinner: widget.querySelector(
          ".merchants-lookup-widget__map-loading",
        ),
        valueKey: widget.dataset.merchantsLookupValueKey,
        companyId: widget.dataset.merchantsLookupCompanyId,
        country: widget.dataset.merchantsLookupCountry,
        group_name: widget.dataset.merchantsLookupGroupName,
        map: new google.maps.Map(mapElement, {
          center: new google.maps.LatLng(51.5074, 0.1278),
          zoom: 8,
          disableDefaultUI: true,
        }),
        markers: [],
      };

      state.postcodeInput.onkeypress = function (e) {
        if ((e.keyCode || e.which || e.charCode || 0) === 13) {
          search(state);
          return false;
        }
        return true;
      };

      if (document.readyState === "loading") {
        document.addEventListener(
          "DOMContentLoaded",
          function (e) {
            setupPostcodeValidation(state);
          },
          false,
        );
      } else {
        setupPostcodeValidation(state);
      }

      state.searchButton.addEventListener("click", () => search(state), false);
    });
  }

  function setupPostcodeValidation(state) {
    state.postcodeInput.addEventListener("input", function (event) {
      if (this.validity.valid) {
        // Only run the below when the input field is valid (has text)
        if (
          state.merchantSelection.validity.valid == false &&
          hasListLoaded(state) == false
        ) {
          // postcode field has value, but search button hasn't been clicked yet.
          // set custom error.
          this.setCustomValidity(this.dataset.invalidMsg);
          this.reportValidity();

          // Define the callback for search button click
          function onSearchButtonClick(event) {
            // Once the search button has been clicked after postcode input,
            // remove search button click event listener
            // and set postcode input as valid again.
            this.removeEventListener("click", onSearchButtonClick);
            state.postcodeInput.setCustomValidity("");
            state.postcodeInput.reportValidity();
          }

          // Assign search button click callback
          state.searchButton.addEventListener("click", onSearchButtonClick);
        }
      } else if (this.value.trim() == "") {
        this.setCustomValidity("");
      }
    });
  }

  /**
   * Returns whether a list of merchant stores has been loaded
   * by searching for postcode
   *
   * @param {*} state
   * @returns bool
   */
  function hasListLoaded(state) {
    return (
      state.resultsContainer.querySelectorAll(".selected-merchant").length > 0
    );
  }

  function buildList(merchants, state) {
    state.resultsContainer.innerHTML = "";

    state.mapLoadingSpinner.classList.add("invisible");

    if (merchants.length > 0) {
      merchants = merchants.slice(0, 5);

      for (const [index, merchant] of merchants.entries()) {
        state.resultsContainer.insertAdjacentHTML(
          "beforeend",
          merchantHtml(merchant, index, state),
        );
      }

      state.resultsContainer
        .querySelectorAll(".field")
        .forEach((merchantResultField) => {
          const value = merchantResultField.querySelector("input").value;
          merchantResultField.addEventListener(
            "click",
            (elem) => {
              state.merchantSelection.value = value;
            },
            false,
          );
        });

      buildMarkers(merchants, state);
    } else {
      state.resultsContainer.insertAdjacentHTML(
        "beforeend",
        state.resultsContainer.dataset.invalidMsg,
      );
    }
  }

  function handleSearchError(response) {
    if (!response.ok) {
      throw Error(response.statusText);
    }
    return response;
  }

  function search(state) {
    let postcode = state.postcodeInput.value;

    if (postcode) {
      state.mapLoadingSpinner.classList.remove("invisible");

      var search;
      var path = `/search_merchants?postcode=${postcode}&company_id=${state.companyId}&country=${state.country}&group_name=${encodeURIComponent(state.group_name)}`;

      if (window.DriftrockWidget || window.Driftrock) {
        var url;

        if (window.DriftrockWidget) {
          if (DriftrockWidget.settings.env != "test") {
            path = `/v2${path}`;
          }

          search = fetch(`${DriftrockWidget.baseUrl()}${path}`, {
            headers: {
              Accept: "application/json",
              Authorization: `Bearer ${DriftrockWidget.settings.api_key}`,
              "Content-Type": "application/json",
            },
          });
        } else {
          if (Driftrock.settings.env != "test") {
            path = `/v2${path}`;
          }

          search = fetch(`${Driftrock.settings.base_url}${path}`, {
            headers: {
              Accept: "application/json",
              Authorization: `Bearer ${Driftrock.settings.api_key}`,
              "Content-Type": "application/json",
            },
          });
        }
      } else {
        search = fetch(path);
      }

      search
        .then(handleSearchError)
        .then((response) => response.json())
        .then((response) => {
          if (response.data) {
            buildList(response.data, state);
          } else {
            buildList(response, state);
          }
        })
        .catch((error) => buildList([], state))
        .then(() => {
          // If locations were loaded we can clear any error messages from the postcode search input
          if (hasListLoaded(state)) {
            state.postcodeInput.setCustomValidity("");
            state.postcodeInput.reportValidity();
          }
        });
    }
  }

  function buildMarkers(merchants, state) {
    let bounds = new google.maps.LatLngBounds();

    for (const marker of state.markers) {
      marker.setMap(null);
    }

    state.markers = [];

    for (const [index, merchant] of merchants.entries()) {
      let latlng = new google.maps.LatLng(
        merchant.latitude,
        merchant.longitude,
      );

      let marker = new google.maps.Marker({
        position: latlng,
        map: state.map,
        label: labels[index % labels.length],
        title: merchant.name,
      });

      state.markers.push(marker);

      bounds.extend(latlng);
    }
    state.map.fitBounds(bounds);
    state.map.panToBounds(bounds);
  }

  function merchantHtml(merchant, index, state) {
    const merchant_location = [
      merchant.address,
      merchant.city,
      merchant.postal_code,
      merchant.country,
    ]
      .filter((v) => v != null && v != "")
      .join(", ");

    return `<a class="panel-block">
      <div class="form__input field">
        <input class="is-checkradio" id="selected_merchant_${index}" type="radio" name="${state.valueKey}" value="${merchant.external_id}">
        <label class="merchants-lookup-widget__radio-label" for="selected_merchant_${index}">
          <div class="selected-merchant">
            <div class="selected-merchant__name">
              ${labels[index % labels.length]} - ${merchant.name}
            </div>
            <div class="selected-merchant__location">
              ${merchant_location}
            </div>
          </div>
        </label>
      </div>
    </a>`;
  }

  init_inputs();
};

export { init };
